import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Balancer from './Balancer';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<Balancer />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js